import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { CircleCheck, CircleX } from 'lucide-react';
import { getApiUrl } from '../../utils/apiConfig';

const EditAdministracionContent = ({ onSave, onCancel }) => {
  const [searchParams] = useSearchParams();
  const email = searchParams.get('edit');
  const [permiso, setPermiso] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [successMsg, setSuccessMsg] = useState('');
  const [errorMsg, setErrorMsg] = useState('');

  useEffect(() => {
    const fetchPermiso = async () => {
      setLoading(true);
      try {
        const res = await fetch(getApiUrl(`/api/permisosAdmin/${email}`), { credentials: 'include' });
        if (res.ok) {
          const data = await res.json();
          setPermiso(data);
        } else {
          setErrorMsg('No se pudo cargar el permiso');
        }
      } catch (err) {
        setErrorMsg('Error de red');
      } finally {
        setLoading(false);
      }
    };
    if (email) fetchPermiso();
  }, [email]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPermiso(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setErrorMsg('');
    setSuccessMsg('');
    try {
      const res = await fetch(getApiUrl(`/api/permisosAdmin/${email}`), {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify(permiso),
      });
      if (res.ok) {
        setSuccessMsg('Permiso actualizado correctamente');
        onSave && onSave();
      } else {
        setErrorMsg('Error al actualizar el permiso');
      }
    } catch (err) {
      setErrorMsg('Error de red');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return <div className="py-16 text-center text-gray-600">Cargando permiso...</div>;
  }
  if (!permiso) {
    return <div className="py-16 text-center text-red-600">No se encontró el permiso</div>;
  }

  return (
    <div className="max-w-lg mx-auto bg-white rounded-2xl shadow-xl p-6">
      <h2 className="text-xl font-bold mb-4">Editar Permiso Comercial</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700">Email</label>
          <input type="email" name="EmailUser" value={permiso.EmailUser} onChange={handleChange} required className="w-full px-3 py-2 border rounded-xl" disabled />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700">Función Comercial</label>
          <input type="text" name="FuncionComercial" value={permiso.FuncionComercial || ''} onChange={handleChange} className="w-full px-3 py-2 border rounded-xl" />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700">Comerciales</label>
          <input type="text" name="C_Comerciales" value={permiso.C_Comerciales || ''} onChange={handleChange} className="w-full px-3 py-2 border rounded-xl" />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700">Bloques</label>
          <input type="text" name="O_Bloques" value={permiso.O_Bloques || ''} onChange={handleChange} className="w-full px-3 py-2 border rounded-xl" />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700">Ubicaciones</label>
          <input type="text" name="O_Ubicaciones" value={permiso.O_Ubicaciones || ''} onChange={handleChange} className="w-full px-3 py-2 border rounded-xl" />
        </div>
        {errorMsg && <div className="text-red-600 text-sm flex items-center gap-2"><CircleX size={16} /> {errorMsg}</div>}
        {successMsg && <div className="text-green-600 text-sm flex items-center gap-2"><CircleCheck size={16} /> {successMsg}</div>}
        <div className="flex gap-3 justify-end mt-4">
          <button type="button" onClick={onCancel} className="px-4 py-2 rounded-xl bg-gray-200 text-gray-700">Cancelar</button>
          <button type="submit" disabled={saving} className="px-4 py-2 rounded-xl bg-blue-600 text-white font-semibold hover:bg-blue-700 transition-all">{saving ? 'Guardando...' : 'Guardar'}</button>
        </div>
      </form>
    </div>
  );
};

export default EditAdministracionContent;
